
import { useState } from 'react';
import './main-page-skelton.css'
import { Link } from 'react-router-dom';

export default function Skeleton() {

    const [loading, setLoading] = useState(true);

    if (loading) {
        setTimeout(() => {
            setLoading(false);
        }, 1000);
        return (
          <div style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', height:'100vh'}}>
            <img style={{width: '80%'}} src='/ontimeurban-logo.png' alt='logo'></img>
            <div className="spinner" style={{borderColor: 'whitesmoke', borderLeftColor: '#2c5f2d', height: '20px', width: '20px'}}></div>
            <p style={{fontSize:'20px', fontWeight:'bold', fontFamily:'Arial', color:'#2c5f2d'}}>Loading...</p>
          </div>
        );
      }

    return (
        <>
            <div style={{padding: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '0'}}>
                <div className='location-container'>
                    <div style={{display:'flex', flexDirection:'row', alignItems:'baseline'}}>
                        <p className='delivery-time'>Delivering in </p>
                        <img src='/icons/thunderbolt.png' alt='thunderbolt-logo' style={{height:'15px', width:'18px', margin:'0 0 0 2px'}}/>
                        <p className='delivery-time' style={{color:'green'}}>15 Mins</p>
                    </div>
                    <div className='address-container'>
                        <p className='address'>Select Address</p>
                        <span className='down-arrow'>&#9662;</span>   
                    </div>
                </div>
                <div>    
                    <div className='open-icon' style={{margin:'5px'}}></div>
                    <div className='open-icon' style={{margin:'5px'}}></div>
                    <div className='open-icon' style={{margin:'5px'}}></div>
                </div>
            </div>
            <div>
                <div className='header-main-container-bottom' style={{ width:'95%', height:'45px', borderRadius:'10px', margin:'10px 5px' }}>
                    <img src='/find.png' alt='search' className='header-main-search-logo' />
                    <p className='header-main-search-text'>Search for <span style={{fontWeight:'bold'}}>"Sugar"</span></p>
                </div>
  
                <div className="poster-skelton"></div>
                <div>
                    <div className="name-see-all-skeleton">
                        <div className="skelton-body" style={{ width:'170px', height:'20px', borderRadius:'5px' }}></div>
                        <div className="skelton-body" style={{ width:'50px', height:'20px', borderRadius:'5px' }}></div>
                    </div>
                    <div className="horizontal-list-skeleton">
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                    </div>     
                </div>
                <div>
                    <div className="name-see-all-skeleton">
                        <div className="skelton-body" style={{ width:'170px', height:'20px', borderRadius:'5px' }}></div>
                        <div className="skelton-body" style={{ width:'50px', height:'20px', borderRadius:'5px' }}></div>
                    </div>
                    <div className="horizontal-list-skeleton">
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto'}}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                        <div className="skelton-body" style={{ height: '240px', width: '150px', borderRadius: '10px', flex:'0 0 auto' }}></div>
                    </div>     
                </div>
            </div>
        </>
    );
}